// UK Vehicle Registration plate format validator.
//
// Accepts the major DVLA plate styles in use today:
//   - Current  (2001+):   AB12 CDE      2 letters + 2 digits + 3 letters
//   - Prefix   (1983-01): A123 BCD      1 letter  + 1-3 digits + 3 letters
//   - Suffix   (1963-83): ABC 123A      3 letters + 1-3 digits + 1 letter
//   - Dateless letters→digits:   ABC 1234        1-3 letters + 1-4 digits (covers NI too)
//   - Dateless digits→letters:   1234 ABC        1-4 digits + 1-3 letters
//
// Personalised/cherished plates that follow one of the above structures pass.
// OCR junk like "2FBJXDC" (digit + 6 letters) correctly fails.

const PATTERNS = [
  /^[A-Z]{2}[0-9]{2}[A-Z]{3}$/,    // Current
  /^[A-Z][0-9]{1,3}[A-Z]{3}$/,     // Prefix
  /^[A-Z]{3}[0-9]{1,3}[A-Z]$/,     // Suffix
  /^[A-Z]{1,3}[0-9]{1,4}$/,        // Dateless letters→digits (also NI)
  /^[0-9]{1,4}[A-Z]{1,3}$/,        // Dateless digits→letters
];

export const isValidUKVehicleReg = (raw) => {
  if (!raw || typeof raw !== 'string') return false;
  const clean = raw.replace(/\s+/g, '').toUpperCase();
  if (clean.length < 2 || clean.length > 8) return false;
  return PATTERNS.some((p) => p.test(clean));
};

// Pretty-print a canonical (unspaced) reg with the conventional UK space
// in the right slot. Returned for DISPLAY only — formData always stores the
// canonical unspaced version so downstream broker payloads stay clean.
//   AB12CDE  -> "AB12 CDE"   (current 2001+)
//   A123BCD  -> "A123 BCD"   (prefix 1983-01)
//   ABC123A  -> "ABC 123A"   (suffix 1963-83)
//   ABC1234  -> "ABC 1234"   (dateless / NI letters→digits)
//   1234ABC  -> "1234 ABC"   (dateless digits→letters)
//   anything else (partial typing, unrecognised) -> returned unchanged
export const formatUKVehicleReg = (raw) => {
  if (!raw || typeof raw !== 'string') return '';
  const c = raw.replace(/\s+/g, '').toUpperCase();
  if (!c) return '';
  // Don't space-format very short partial inputs (1-4 chars). The dateless
  // patterns would otherwise turn "AB1" into "AB 1" mid-typing and the space
  // would jump around as the user keeps typing. Wait until we're at typical
  // UK plate length (5+ chars) before inserting the canonical space.
  if (c.length < 5) return c;
  let m;
  if ((m = c.match(/^([A-Z]{2}[0-9]{2})([A-Z]{3})$/))) return `${m[1]} ${m[2]}`;
  if ((m = c.match(/^([A-Z][0-9]{1,3})([A-Z]{3})$/))) return `${m[1]} ${m[2]}`;
  if ((m = c.match(/^([A-Z]{3})([0-9]{1,3}[A-Z])$/))) return `${m[1]} ${m[2]}`;
  if ((m = c.match(/^([A-Z]{1,3})([0-9]{1,4})$/))) return `${m[1]} ${m[2]}`;
  if ((m = c.match(/^([0-9]{1,4})([A-Z]{1,3})$/))) return `${m[1]} ${m[2]}`;
  return c;
};
